import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { EPosition } from '../../../../filters/components/filters/filters';
import { closedCoworkingPopup } from '../../../../serp/state/coworking_experiments/coworkingPopup';

import { IAppState } from '../../../state';

import { CoworkingPopup as CoworkingPopupComponent } from './CoworkingPopup';

interface ICoworkingPopupContainer {
  className?: string;
}

export const CoworkingPopup: React.FC<ICoworkingPopupContainer> = props => {
  const isCoworkingPopupVisible = useSelector<IAppState, boolean>(
    state => state.coworkingExperiments.coworkingPopup.isOpen,
  );
  const filtersPosition = useSelector<IAppState, EPosition>(
    state => state.coworkingExperiments.coworkingPopup.filtersPosition,
  );
  const dispatch = useDispatch();
  const onClose = React.useCallback(() => {
    dispatch(closedCoworkingPopup());
  }, []);

  if (!isCoworkingPopupVisible) {
    return null;
  }

  return <CoworkingPopupComponent {...props} onClose={onClose} filtersPosition={filtersPosition} />;
};

CoworkingPopup.displayName = 'CoworkingPopupComponent';
